<template>
  <div style="position:relative; min-height: 500px;">
    <div class="columns is-multiline">
      <div class="column is-4" v-for="magazine in magazines.data" :key="magazine.id">
        <b-checkbox
          :value="value.includes(magazine.id)"
          @input="value => onInput(magazine, value)"
        >{{ magazine.name }}</b-checkbox>
      </div>
    </div>

    <b-loading :active="magazines.loading" :is-full-page="false"></b-loading>
  </div>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      magazines: new window.RemoteCollection(
        "/admin/api/magazine/magazines?paginate=false"
      ).load(),

      localValue: this.value
    };
  },

  methods: {
    onInput(magazine, checked) {
      let index = this.localValue.indexOf(magazine.id);

      if (checked && index == -1) {
        this.localValue.push(magazine.id);

        this.$emit("input", this.localValue);
      } else if (!checked && index > -1) {
        this.localValue.splice(index, 1);

        this.$emit("input", this.localValue);
      }
    }
  }
};
</script>
